module.exports = __webpack_public_path__ + "teste_parallax.97eb1029385156765e01.jpg";


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/assets/teste_parallax.jpg
// module id = ../../../../../src/assets/teste_parallax.jpg
// module chunks = main